































import 'vue-height-tween-transition/index.css'
import HeightTween from 'vue-height-tween-transition'

export default

	components: { HeightTween }

	props:
		title: String
		open: Boolean
		uncloseable: Boolean
		paneWidth: String

	# Store our own pane state, so this can be used in isolation or as part of
	# an accordion where only one is open at a time
	data: -> isOpen: @open

	computed:

		# Disable the pane if it is uncloseable and open
		disabled: -> @uncloseable && @isOpen

	watch:

		# Sync the open state
		open: -> @isOpen = @open

		# Even events when it's opened / closed
		isOpen: ->
			if @isOpen then @$emit 'open' else @$emit 'close'
			@$emit 'toggle', @isOpen


	methods:

		# Handle toggle clicks
		onToggle: ->
			return if @uncloseable and @isOpen
			@isOpen = !@isOpen

